import { call, put, all, takeLatest } from 'redux-saga/effects';

import { searchAPIs } from 'apis/services/search';
import { ActionTypeEnum } from 'redux/ActionTypeEnum';
import { loadingAction } from 'redux/settings/action';

import { provincesActionSuccess } from './action';

////province And City
function* provincesRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(searchAPIs.provinces, payload);

		yield put(provincesActionSuccess(response.data?.Content));
		yield put(loadingAction({ form: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

export default function* provincesSaga() {
	yield all([takeLatest(ActionTypeEnum.provinces_request, provincesRequest)]);
}
